export class PackageQuarterQueryRequest {
    body: PackageQuarterQueryBody = new PackageQuarterQueryBody();
}

export class PackageQuarterQueryBody {
    ProcessName: string = 'DC Community Portal SR Process Wrapper WF';
    DCMethod: string = 'QUERY_PACKAGE_QUARTER';
    DCLoginName: string = '';
    DCLanguage: string = 'ENU';
    DCIncomingHierarchy: PackageQuarterQueryDCIncomingHierarchy =
        new PackageQuarterQueryDCIncomingHierarchy();
}

export class PackageQuarterQueryDCIncomingHierarchy {
    MessageId: string = '';
    IntObjectName: string = 'DC Master Data IO';
    MessageType: string = 'Integration Object';
    IntObjectFormat: string = 'Siebel Hierarchical';
    'ListOfDC Master Data IO': PackageQuarterListOfDCMasterDataIO =
        new PackageQuarterListOfDCMasterDataIO();
}

export class PackageQuarterListOfDCMasterDataIO {
    'DC Quarter List BC': PackageQuarterListBC =
        new PackageQuarterListBC();
}

export class PackageQuarterListBC {
    CSN: string = '';
    'SR Type': string = 'Service Excellence Programme';
    'Sub Type': string = 'Mystery Shopper Membership';
}
